/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SendSmsOtpRequest = {
  properties: {
    type: {
      type: 'Enum',
      isRequired: true,
    },
    phone: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
